import React from "react";
import { cn } from "@/lib/utils";

/** Analysis lifecycle statuses, mirrored from the Django `Analysis` shadow. */
export type VbStatus = "PENDING" | "IN_PROGRESS" | "DONE" | "FAILED";

const CONFIG: Record<VbStatus, { label: string; cls: string }> = {
  DONE: { label: "Done", cls: "vb-status--done" },
  IN_PROGRESS: { label: "Running…", cls: "vb-status--running" },
  PENDING: { label: "Queued", cls: "vb-status--queued" },
  FAILED: { label: "Failed", cls: "vb-status--failed" },
};

type Props = {
  status: VbStatus;
  /** Override the default label. */
  label?: string;
  className?: string;
};

/** Run status - colored dot + bold label (ported from the prototype's
 *  `.b-run .st`; Running pulses). Not a filled pill. */
export function StatusPill({ status, label, className }: Props) {
  const cfg = CONFIG[status];
  return (
    <span className={cn("vb-status", cfg.cls, className)}>
      <span className="vb-status__dot" />
      {label ?? cfg.label}
    </span>
  );
}

export default StatusPill;
